module.exports = __webpack_public_path__ + "img/Save_State_Up.ab01b862.svg";